import React from "react";
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import schema from "./Data/GroupCRUDConfig.json";
import PageHeader from "../../components/PageHeader";
import "../../Assets/Styles/Style.css";
import CardSummary from "../../utils/Card/CardSummary";
import { Box } from "@mui/material";

const GroupsPage = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ flexGrow: 1, marginTop:0, marginLeft: 15,  marginRight: 15, marginBottom:15}} >
        <PageHeader pageTitle="Manage Your Groups" />
        <div>
          <CardSummary
            cards={[
              {
                title: "Total Groups",
                dataKey: "total_groups",
                image: "./assets/img/Groups.png",
              },
              {
                title: "Subscriptions",
                dataKey: "total_subscriptions",
                image: "./assets/img/subscribe.png",
              },
              {
                title: "Investments",
                dataKey: "total_invested",
                image: "./assets/img/total-subscription.png",
              },
              {
                title: "Penalty",
                dataKey: "total_penalty",
                image: "./assets/img/penalty-card.png",
              },
            ]}
          />
        </div>

        <hr />

        <CrudManager
          data={schema}
          actionBtnName="Add New Group"
          createFormTitle="Add Group"
          updateFormTitle="Update Group"
        />
      </Box>
    </Box>
  );
};
export default GroupsPage;
